import BreadcrumbsBlock from '@/blocks/BreadcrumbsBlock';
import TimelineBlock from '@/blocks/TimelineBlock';
import FancyHeading from '@/components/FancyHeading';
import { fadeIn, fadeInUp } from '@/constants/motions';
import { pages } from '@/content';
import FullWidthLayout from '@/layouts/FullWidthLayout';
import { motion } from 'framer-motion';
import graphql from '@/lib/graphql';
import mainLayout from '@/graphql/queries/mainLayout';
import Markdown from 'react-markdown';
import page from '@/graphql/queries/page';
import { REVALIDATE_TIME_IN_SEC } from '@/constants/env';

export default function HistoryPage({ mainLayout, page }) {
  let { contentSection, metaData } = page.attributes;
  return (
    <FullWidthLayout mainLayout={mainLayout} metaData={metaData}>
      <BreadcrumbsBlock items={[pages.home, pages.about, pages.history]} />
      <motion.section
        className="my-16 px-4"
        initial="hidden"
        transition={{
          ...fadeIn.transition,
          when: 'beforeChildren',
          staggerChildren: 0.4,
        }}
        variants={fadeIn}
        viewport={fadeIn.viewport}
        whileInView="visible"
      >
        <div className="container-screen">
          <FancyHeading variants={fadeInUp}>{contentSection[0].title}</FancyHeading>
          <motion.article
            className="prose prose-neutral mx-auto mt-6 max-w-screen-md text-center"
            variants={fadeInUp}
          >
            {contentSection[0].description}
          </motion.article>
        </div>
      </motion.section>
      <TimelineBlock items={contentSection[0].timeline} />
    </FullWidthLayout>
  );
}

export async function getStaticProps() {
  const { data: mainLayoutData } = await graphql(mainLayout);

  const { data: pageData } = await graphql(page, { slug: 'history' });

  return {
    props: {
      mainLayout: mainLayoutData.mainLayout.data,
      page: pageData.pages.data[0],
    },
    revalidate: parseInt(REVALIDATE_TIME_IN_SEC), // In seconds
  };
}
